export const FooterBottom = () => {
  return (
    <div className="flex flex-col items-center space-y-4">
      <div className="text-sm text-white/80">
        <a 
          href="https://feelinx.dev" 
          target="_blank" 
          rel="noopener noreferrer"
          className="hover:text-white transition-colors"
        >
          Powered by Feelinx
        </a>
      </div>
      
      <p className="text-sm text-white/80">
        © 2024 Les Fous du Volant. Tous droits réservés.
      </p>
    </div>
  );
};